var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.703 1.667H2.256A1.43 1.43 0 00.833 3.089v13.822c0 .78.643 1.422 1.423 1.422h15.447a1.43 1.43 0 001.423-1.422V3.089a1.43 1.43 0 00-1.423-1.422zm-10 10.284V8.05h4.553v3.902H7.703zm4.553 1.22v3.943H7.703V13.17h4.553zM2.053 8.049h4.43v3.902h-4.43V8.05zm5.65-1.22V2.886h4.553V6.83H7.703zm5.773 1.22h4.43v3.902h-4.43V8.05zm4.43-4.96v3.74h-4.43V2.886h4.227c.114 0 .204.09.204.203zm-15.65-.203h4.228V6.83H2.053V3.09c0-.113.09-.203.203-.203zm-.203 14.025v-3.74h4.43v3.943H2.257a.201.201 0 01-.203-.203zm15.65.203h-4.227V13.17h4.43v3.74a.201.201 0 01-.203.203z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.aef1f2e6.svg";
export { ForwardRef as ReactComponent };